module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-5.jpg?37af341c";